import * as types from "./actionTypes";
import { showAlertSuccess } from "./alertActions";
import exportService from "../services/exportService";

export function exportSuccess(data) {
  return {
    type: types.EXPORT_SUCCESS,
    data
  };
}

export function isExporting(exporting) {
  return {
    type: types.EXPORTING,
    exporting
  };
}

export function clearExported() {
  return {
    type: types.CLEAR_EXPORTED
  };
}

export function performExport(payload) {
  return async (dispatch) => {
    await dispatch(isExporting(true));
    return exportService
      .performExport(payload)
      .then((data) => {
        if (data.error) {
          throw new Error(data.error);
        }
        dispatch(exportSuccess(data));
        dispatch(isExporting(false));
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error, "error"));
        dispatch(isExporting(false));
      });
  };
}
